import React, { useEffect, useState } from 'react';
import ChatBox from '../pages/experts/Connections/ChatBox';
import { useSelector } from 'react-redux';
import { useData } from '../data';
import AdvertMessage from '../pages/experts/Connections/AdvertMessage';
import ConnectionMessage from '../pages/experts/Connections/ConnectionMessage';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Flex, Text } from '@chakra-ui/react';
import StyledSpinner from './spinner/Spinner';
import UserService from '../utils/UserService';
import { setUnreads } from '../redux-toolkit/reducers/userSlice';

const ChatMessageWidget = ({
  requestListIsOpen,
  isDesktop,
  connections,
  setConnections,
  refetchConnections,
  connectionsLoading,
  sortFn,
  recipient,
  setRecipient,
  recipientId,
  selectedAdvert,
  advertId,
  isAdvert,
  isFromNavigate,
  openChatBox,
  openAdvert,
  closeChatBox,
  chatBoxIsOpen,
}) => {
  const userDetails = useSelector((state) => state?.user?.userInfo);
  const unreads = useSelector((state) => state?.user?.unreads);
  const [showMessageTray, setShowMessageTray] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const {
    data: inboxAdverts,
    isLoading: inboxAdvertsLoading,
    refetch: refetchInboxAdverts,
  } = useData(`inbox-adverts/`);

  const openMessageTray = () => {
    if (userDetails?.status == 'disabled') return;
    setShowMessageTray((prev) => !prev);
  };



  useEffect(() => {
    const _unreads = Object.keys(unreads || [])
    if (_unreads.length > 0) {
      let count = 0
      for (let item of Object.keys(unreads)) {
        count += unreads?.[item].count > 0 ? 1 : 0
      }
      setUnreadCount(count)
    } else {
      setUnreadCount(0)
    }
  }, [unreads]);


  return (
    <>
      {!requestListIsOpen ? (
        <Flex
          hidden={isDesktop ? false : true}
          className="fixed hidden items-end min-w-max right-10 gap-8 z-10 bottom-0"
        >
          <Flex
            className="bg-white"
            boxShadow="0px 10px 20px rgba(0, 0, 0, 0.05)"
          >
            {chatBoxIsOpen && (
              <Box w={'480px'} h="80vh max-h-[300px]">
                <ChatBox
                  advert={selectedAdvert}
                  advertId={advertId}
                  isAdvert={isAdvert}
                  isFromNavigate={isFromNavigate}
                  recipientId={recipientId}
                  setRecipient={setRecipient}
                  recipient={recipient}
                  closeChatBox={closeChatBox}
                  refetchConnections={refetchConnections}
                  setConnections={setConnections}
                />
              </Box>
            )}
          </Flex>
          <Flex
            boxShadow="0px 10px 20px rgba(0, 0, 0, 0.05)"
            className="flex-col bg-white min-w-[300px] rounded-t-md z-10"
          >
            <Flex
              bgColor="#134A70"
              className="items-center justify-between py-2 px-3 rounded-t-md cursor-pointer"
              onClick={openMessageTray}
            >
              <Box className='flex items-center justify-center gap-2'>
                <Text
                  fontSize={{ base: 14 }}
                  fontWeight={800}
                  ml={{ base: '3rem', lg: 0 }}
                  color="#fff"
                >
                  New Conversation
                </Text>
                {
                  unreadCount > 0 ? (
                    <Box className='bg-green-500 text-white px-2 py-1 text-sm rounded'>
                      {unreadCount}
                    </Box>
                  ) : null
                }
              </Box>
              <Box>
                {showMessageTray ? (
                  <ChevronDownIcon w={7} h={7} color="white" />
                ) : (
                  <ChevronUpIcon w={7} h={7} color="white" />
                )}
              </Box>
            </Flex>
            <Box className="max-h-[60vh] overflow-y-auto">
              {showMessageTray ? (
                connectionsLoading ? (
                  <StyledSpinner />
                ) : (
                  <>
                    {[...(inboxAdverts?.data?.adverts || []), ...connections]
                      ?.length > 0 ? (
                      [
                        ...(inboxAdverts?.data?.adverts || []),
                        ...connections.filter((b) => b.accepted === true),
                      ]
                        ?.sort(sortFn)
                        ?.map((connection, index) =>
                          connection?.advert_type ? (
                            <AdvertMessage
                              advert={connection}
                              key={index}
                              openChatBox={openAdvert}
                            />
                          ) : (
                            <ConnectionMessage
                              recipient={connection}
                              key={index}
                              openChatBox={openChatBox}
                            />
                          ),
                        )
                    ) : (
                      <Box className="text-center">No connections...</Box>
                    )}
                  </>
                )
              ) : (
                <Box py={1}></Box>
              )}
            </Box>
          </Flex>
        </Flex>
      ) : null}
    </>
  );
};

export default ChatMessageWidget;
